import Immutable from 'immutable';

import type { ActionType } from 'sharedreact/actions/generic/actions';
import Filter from 'sharedreact/data/Filter';
import SortOrder from 'sharedreact/data/SortOrder';
import UploadedFile from 'sharedreact/data/UploadedFile';
import AppDispatcher from 'sharedreact/dispatcher/AppDispatcher';
import ItemsState from 'sharedreact/stores/generic/ItemsState';
import PaginatedItemsStore from 'sharedreact/stores/generic/PaginatedItemsStore';
import { RangeType } from 'sharedreact/stores/generic/Type';

import FontsActions from 'workspaces/launcher/actions/FontsActions';
import FontsConstants from 'workspaces/launcher/constants/FontsConstants';
import FontFile from 'workspaces/launcher/data/FontFile';

const ExtraDataContent: {
  needsConfirmOverwrite: boolean,
  uploadedFiles: Immutable.List<UploadedFile>
} = {
  needsConfirmOverwrite: false,
  uploadedFiles: Immutable.List()
};

class ExtraData extends Immutable.Record(ExtraDataContent) {
}

class FontsStore extends PaginatedItemsStore<FontFile, ExtraData> {
  constructor () {
    super(AppDispatcher, FontsActions, FontsConstants);
  }

  override getInitialState (): ItemsState<FontFile | null, ExtraData> {
    return super.getInitialState().set('extraData', new ExtraData());
  }

  getFilterKeywords (): string[] {
    return ['name', 'modificationdate'];
  }

  getSortKeywords (): string[] {
    return ['name', 'modificationdate', 'size'];
  }

  getItemKeyForKeyword (keyword: string): string {
    switch (keyword) {
      case 'name': {
        return 'name';
      }
      case 'modificationdate': {
        return 'modificationDate';
      }
      case 'size': {
        return 'fileSize';
      }
      default: {
        break;
      }
    }
    return keyword;
  }

  _getAll (
    state: ItemsState<FontFile | null, ExtraData>,
    range: RangeType,
    filter: Filter,
    advancedFilter: Filter,
    groupBy: SortOrder,
    sortOrder: SortOrder
  ): void {
    this.Actions.fetch(range, filter, advancedFilter, groupBy, sortOrder, !state.hasReceivedInitialData);
  }

  override reduce (state: ItemsState<FontFile | null, ExtraData>, action: ActionType): ItemsState<FontFile | null, ExtraData> {
    switch (action.actionType) {
      case FontsConstants.SET_CONFIRM_OVERWRITE: {
        return state
          .set('extraData', state.extraData!
            .set('needsConfirmOverwrite', action.needsConfirmOverwrite)
            .set('uploadedFiles', action.files)
          );
      }
      case FontsConstants.REFRESH: {
        return this._refresh(state);
      }
    }

    return super.reduce(state, action);
  }
}

export default new FontsStore();
